import React from 'react';

const ParkingList = ({
    loading = false,
    error = undefined,
    availableParkings = [],
    handleParkingClicked = () => { }
}) => {
    return (
        <div className="parking-list-root">
            {availableParkings.map(
                park => (
                    <div
                        key={park.id}
                        className="parking-list-item"
                        onClick={() => handleParkingClicked(park.id)}
                    >
                        {park.name}
                    </div>
                )
            )}
        </div>
    );
}

export default ParkingList;